import { Injectable } from '@angular/core';
import { rethrowAsSapError, SapError } from 'src/app/lego-utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserMaterial } from 'src/app/models';
import { UserAuthorizationGroupSetService } from 'src/generated-clients/user_material';

@Injectable({
  providedIn: 'root',
})
export class UserMaterialService {
  public constructor(private readonly userMaterialService: UserAuthorizationGroupSetService) {}

  public getUserIdByEmail(email: string): Observable<UserMaterial> {
    return this.userMaterialService
      .userAuthorizationGroupSetGet(undefined, `emailAddress eq '${email}'`)
      .pipe(
        rethrowAsSapError(),
        map((u) => {
          const results = u.d?.results;

          if (results === undefined) {
            throw new SapError('Sap Error');
          }

          // assuming one result per email
          return results[0];
        })
      );
  }
}
